module.exports = __webpack_public_path__ + "img/1562654242.671a7ecc.jpg";